import awsRestAPI from "@/services/api/awsRestAPI";
import { getUUID } from "@/helpers/helpers";
import { WSS_MESSAGE_TYPES, CHAT_MODES } from "@/helpers/constants";

export default {
  /**
   * Send message to room
   * @param dispatch
   * @param rootGetters
   * @param message
   */
  sendMessage({ dispatch, rootGetters }, { message }) {
    let payload = {
      messageBody: message.text,
      messageUUID: getUUID(),
      isFromStream: false,
      messageType: message.type,
      groupUUID:
        message.type === WSS_MESSAGE_TYPES.TABLE_MESSAGE
          ? rootGetters["tables/userTable"].uuid
          : rootGetters["room/activeRoom"].uuid
    };

    dispatch("socket/sendToSocket", payload, { root: true });
  },
  sendPrivateMessage({ dispatch, commit, state }, { message }) {
    let payload = {
      messageBody: message,
      messageType: WSS_MESSAGE_TYPES.PRIVATE_MESSAGE,
      recipientUUID: state.privateChatTarget.userUUID
    };

    dispatch("socket/sendToSocket", payload, { root: true });
    dispatch(
      "users/createUserConnection",
      {
        targetUserUUID: state.privateChatTarget.userUUID
      },
      { root: true }
    );
    commit("addUserPrivateUser", state.privateChatTarget);
  },
  /**
   * Get room messages
   * @return {Promise<void>}
   */
  async getRoomMessages({ commit, rootGetters }) {
    let response = await awsRestAPI.getGroupMessages({
      groupUUID: rootGetters["room/activeRoom"].uuid
    });
    commit("setRoomMessages", response.data);

    return response.data;
  },

  /**
   * Get table messages
   * @return {Promise<void>}
   */
  async getTableMessages({ rootGetters, commit }) {
    let response = await awsRestAPI.getGroupMessages({
      groupUUID: rootGetters["tables/userTable"].uuid
    });
    commit("setTableMessages", response.data);

    return response.data;
  },

  async getPrivateMessagesHistory({ commit }) {
    let response = await awsRestAPI.getPrivateChatsHistory();
    commit("setUserPrivateMessages", Object.values(response.data.result).flat());

    let targetUsers = [];
    Object.entries(response.data.result).forEach(data => {
      const userUUID = data[0];
      const messagesList = data[1];
      // TODO rebuild user meta
      if (messagesList.length) {
        let message = messagesList[0];
        let userMeta = userUUID === message.userUUID ? message.meta.userMeta : message.meta.recipientMeta;
        targetUsers.push({
          userUUID: userUUID,
          firstName: userMeta.firstName,
          lastName: userMeta.lastName
        });
      }
    });
    commit("setUserPrivateUsers", targetUsers);

    return response.data;
  },

  /**
   * Update message
   * @param state
   * @param payload
   * @return {Promise<void>}
   */
  // eslint-disable-next-line
  async messageUpdate({ state }, payload) {
    return await awsRestAPI.updateGroupMessage(payload);
  },

  /**
   * Delete message
   * @param state
   * @param payload
   * @return {Promise<void>}
   */
  // eslint-disable-next-line
  async messageDelete({ state }, payload) {
    return await awsRestAPI.deleteMessage(payload);
  },

  /**
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async resetAllUnreadMessageCounter({ commit }) {
    let modes = [CHAT_MODES.TABLE, CHAT_MODES.PRIVATE];
    modes.forEach(mode => commit("resetUnreadMessagesCounter", mode));
  }
};
